// pwa.ts — PWA install + display-mode helpers (pure logic, no React).
//
// CV-195: surface install prompt + offline-ready posture.

export interface BeforeInstallPromptEvent extends Event {
  readonly platforms: ReadonlyArray<string>;
  readonly userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
  prompt(): Promise<void>;
}

export function isStandaloneDisplayMode(win: Window = window): boolean {
  // iOS Safari uses navigator.standalone; everyone else uses matchMedia.
  const nav = win.navigator as Navigator & { standalone?: boolean };
  if (nav.standalone === true) return true;
  return win.matchMedia?.('(display-mode: standalone)').matches === true;
}

export function shouldOfferInstall(
  capturedEvent: BeforeInstallPromptEvent | null,
  win: Window = window,
): boolean {
  if (!capturedEvent) return false;
  if (isStandaloneDisplayMode(win)) return false;
  return true;
}
